// extracted by mini-css-extract-plugin
module.exports =  {"tc-badge-list":"TextMode-module__tc-badge-list___Gc7O8"};